import { useQuery } from "react-query";
import { useApiError } from "src/hooks/useApiError";
import { getCashUserStatus } from "src/service/pay";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";

interface IUseGetCashStatusProps {
  onSuccess?: () => void;
  onError?: () => void;
}
// 내가 구매한 요금제(현금결제) 상태 조회
// 주의: 데이터 조회 전용 훅. 라우팅 등 부수효과는 호출부에서 onSuccess로 처리할 것
// (과거 기본 onSuccess가 REJECT/DONE 시 라우팅했으나 모든 호출부가 무력화하고 있어 제거)
export function useGetCashStatus({
  onSuccess,
  onError,
}: IUseGetCashStatusProps = {}) {
  const { handleError } = useApiError();
  const [userInfo] = useRecoilState(userInfoAtom);
  // 내가 구매한 요금제 정보
  const {
    isLoading: userCashStatusLoading,
    data: userCashStatus,
    refetch: userCashStatusRefetch,
  } = useQuery(
    ["getCashStatus", getProductFromSessionStorage()],
    async () =>
      await getCashUserStatus({
        product: [getProductFromSessionStorage()],
      }),
    {
      enabled: userInfo?.loginType !== "",
      refetchOnMount: true, // 컴포넌트가 마운트될 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      refetchOnWindowFocus: true, // 윈도우가 포커스를 받을 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      keepPreviousData: false,
      onSuccess,
      onError: onError ? onError : handleError,
    }
  );

  return { userCashStatusLoading, userCashStatus, userCashStatusRefetch };
}
